export var isOldPriceVisible = function isOldPriceVisible(_ref) {
  var currentFormatted = _ref.currentFormatted,
    old = _ref.old;
  return Boolean(old) && old !== currentFormatted;
};
//# sourceMappingURL=isOldPriceVisible.js.map